<template>
  <transition name="fade-in-up">
    <div class="main">
      <KTCodePreview v-bind:title="title">
        <template v-slot:toolbar>
          <div class="row">
            <div class="ml-0">
              <b-button
                variant="primary"
                size="sm"
                :disabled="onLoading"
                @click="
                  showModalAddShippingUnit();
                  isNew = true;
                "
              >
                <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm mới
              </b-button>
            </div>
          </div>
        </template>
        <template v-slot:preview>
          <div class="col-md-12 mb-5">
            <b-form @submit.prevent="fetchShippingUnits()">
              <b-row class="mb-5">
                <b-col class="pl-0">
                  <b-input
                    v-model="searchName"
                    placeholder="Nhập tên đơn vị vận chuyển"
                    size="sm"
                  ></b-input>
                </b-col>
                <b-col></b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col md="1" style="padding-left: 0">
                  <b-button
                    :disabled="onLoading"
                    style="font-weight: 600; width: 70px"
                    variant="primary"
                    size="sm"
                    @click="fetchShippingUnits()"
                  >
                    Lọc
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
          <b-row>
            <b-col cols="12">
              <b-table
                :items="listItem"
                :fields="fields"
                :busy="onLoading"
                bordered
              >
                <template v-slot:cell(status)="row">
                  <span
                    v-if="row.item.status === 1"
                    v-text="'Hoạt động'"
                    class="label font-weight-bold label-lg label-light-success label-inline"
                  ></span>
                  <span
                    v-if="row.item.status === 0"
                    v-text="'Ngừng hoạt động'"
                    class="label font-weight-bold label-lg label-light-danger label-inline"
                  ></span>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-dropdown size="sm" id="dropdown-left" no-caret right>
                    <template slot="button-content">
                      <i
                        style="font-size: 1rem; padding-right: 0px"
                        class="flaticon2-settings"
                      ></i>
                    </template>
                    <b-dropdown-item
                      @click="
                        editItem(row.item);
                        isNew = false;
                      "
                    >
                      <span style="color: #3f4254; font-size: 12px"></span>
                      <i
                        style="font-size: 1rem"
                        class="flaticon2-pen icon-color"
                      ></i>
                      &nbsp; Chỉnh sửa
                    </b-dropdown-item>
                    <!-- <b-dropdown-item @click="showDeleteAlert(row.item.id)">
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem; color: #d33"
                          class="flaticon2-rubbish-bin-delete-button"
                        ></i>
                        &nbsp; Xóa
                      </span>
                    </b-dropdown-item> -->
                  </b-dropdown>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <div class="paging">
            <div class="total">
              <p class="mt-3 text-dark" style="font-weight: 500">
                Tổng số:
                {{ totalItem }}
              </p>
            </div>
            <div class="paging-nav">
              <BPaginationNavCustom
                :number-of-pages="totalPage"
                :current-page="page"
                :total-page="totalPage"
                :linkParams="{}"
                @page-change="fetchShippingUnits"
              />
            </div>
          </div>
          <b-col></b-col>
          <b-col></b-col>
          <b-modal
            ref="add-shipping-unit-modal"
            hide-footer
            title="Thêm mới đơn vị vận chuyển"
            @hidden="resetData"
          >
            <v-form v-model="valid" lazy-validation>
              <div class="w-50">
                <b-form-group
                  id="input-group-shipping-unit-name"
                  label-for="input-shipping-unit-name"
                >
                  <template v-slot:label>
                    <span>Tên đơn vị vận chuyển:</span>
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="input-shipping-unit-name"
                    v-model="upsertItem.name"
                    type="text"
                    placeholder="Nhập tên đơn vị vận chuyển"
                    size="sm"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="w-50">
                <b-form-group
                  id="input-group-shipping-unit-notes"
                  label="Ghi chú"
                  label-for="input-shipping-unit-notes"
                >
                  <!-- v-model="form.email" -->
                  <b-form-textarea
                    id="input-shipping-unit-notes"
                    v-model="upsertItem.notes"
                    placeholder="Nhập ghi chú"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
              </div>
              <div class="w-50" v-show="isNew === false">
                <b-form-group
                  id="input-group-3"
                  label="Trạng thái:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="upsertItem.status"
                    :options="listStatus"
                    required
                    size="sm"
                    value-field="id"
                    text-field="name"
                    disabled-field="notEnabled"
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null"
                        >-- Chọn trạng thái --</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>
              <b-button
                style="font-weight: 600; width: 70px"
                variant="primary"
                size="sm"
                @click="createShippingUnit"
              >
                Lưu
              </b-button>
              <b-button
                style="margin-left: 10px; font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                @click="hideModalAddShippingUnit"
              >
                Hủy
              </b-button>
            </v-form>
          </b-modal>
        </template>
      </KTCodePreview>
    </div>
  </transition>
</template>

<script>
import { cloneDeep } from 'lodash';
import ApiService from '@/core/services/api.service';
import { SET_MENU } from '@/core/services/store/modules/menu.module';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { SideBar } from '@/core/config/menu/sideBar';
import KTCodePreview from '@/view/content/CodePreview.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';

export default {
  mounted() {
    this.$store.dispatch(SET_MENU, SideBar.STORE);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Đơn vị vận chuyển', route: '/shipping-units' },
    ]);
    this.fetchShippingUnits();
  },
  data() {
    return {
      title: 'Danh sách đơn vị vận chuyển',
      page: 1,
      totalPage: 1,
      totalItem: 0,
      onLoading: false,
      listItem: [],
      searchName: '',
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      fields: [
        {
          key: 'selected',
          label: '',
          thStyle: { textAlign: 'center' },
          tdClass: 'selectedProClass',
          thClass: 'selectedProClass',
        },
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'sttProClass',
          thClass: 'sttProClass',
        },
        {
          key: 'name',
          label: 'Tên đơn vị vận chuyển',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'nameProClass',
          thClass: 'nameProClass',
        },
        {
          key: 'notes',
          label: 'Ghi chú',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'notesProClass',
          thClass: 'notesProClass',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'statusProClass text-center',
          thClass: 'statusProClass',
        },
        {
          key: 'creator.employee.fullName',
          label: 'Tạo bởi',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'createdByProClass',
          thClass: 'createdByProClass',
        },
        {
          key: 'updater.employee.fullName',
          label: 'Cập nhật bởi',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'updatedByProClass',
          thClass: 'updatedByProClass',
        },
        {
          key: 'actions',
          label: '',
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'actionProClass',
          thClass: 'actionProClass',
        },
      ],
      listStatus: [
        {
          id: 0,
          name: 'Không hoạt động',
        },
        {
          id: 1,
          name: 'Hoạt động',
        },
      ],
      valid: false,
      upsertItem: {
        name: '',
        notes: '',
        status: null,
      },
      name: '',
      notes: '',
      selectedStatus: null,
      isNew: true,
    };
  },
  components: { KTCodePreview, BPaginationNavCustom },
  methods: {
    fetchShippingUnits: async function () {
      this.page = this.$route.query.page;
      if (!this.page) {
        this.page = 1;
      }
      let params = {
        page: this.page,
        limit: 10,
        name: this.searchName,
      };
      this.onLoading = true;
      ApiService.setHeader();
      ApiService.query('shipping-unit', { params })
        .then(({ data }) => {
          this.totalItem = data.data.totalItems;
          this.totalPage = data.data.totalPages;
          this.listItem = data.data.result;
        })
        .catch(({ response }) => {
          makeToastFaile(response.data.message);
        })
        .finally(() => (this.onLoading = false));
    },
    showModalAddShippingUnit() {
      this.$refs['add-shipping-unit-modal'].show();
    },
    hideModalAddShippingUnit() {
      this.resetData();
      this.$refs['add-shipping-unit-modal'].hide();
    },
    createShippingUnit() {
      this.onLoading = true;
      ApiService.setHeader();
      this.upsertItem.status = this.upsertItem.status ? true : false;
      const result = this.isNew
        ? ApiService.post('shipping-unit', this.upsertItem)
        : ApiService.put(
            `shipping-unit/${this.upsertItem.id}`,
            this.upsertItem,
          );
      result
        .then(({ data }) => {
          makeToastSuccess(data.message);
          this.fetchShippingUnits();
          this.hideModalAddShippingUnit();
        })
        .catch(({ response }) => {
          makeToastFaile(response?.data?.message);
        })
        .finally(() => (this.onLoading = false));
    },
    editItem(item) {
      this.upsertItem = cloneDeep(item);
      this.showModalAddShippingUnit();
    },
    resetData() {
      this.upsertItem = { name: '', notes: '', status: null };
    },
  },
};
</script>
